import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class TaskFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetPdf(taskId: number, storeId: number): Observable<any> {
            return this._httpClient.get<any>(this._urlBase
                 + 'api/Task/ReportLevelChangePdf?taskId=' + taskId + '&storeId=' + storeId);
    }
    
}